import { render, staticRenderFns } from "./HouseConfig.vue?vue&type=template&id=07961524&scoped=true&"
import script from "./HouseConfig.vue?vue&type=script&lang=js&"
export * from "./HouseConfig.vue?vue&type=script&lang=js&"
import style0 from "./HouseConfig.vue?vue&type=style&index=0&id=07961524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07961524",
  null
  
)

export default component.exports